import { ClassScheduleDto } from '../models/class-schedule-dto';

export class StudentClassDto {

  constructor() {
    this.id = '';
    this.studentId = '';
    this.classSchedule = new ClassScheduleDto();
    this.registrationCompletedDate = '';
    this.chkNo = '';
    this.amount = '0.00';
  }

  id: string;
  studentId: string;
  classSchedule: ClassScheduleDto;
  registrationCompletedDate: string;
  chkNo: string;
  amount: string;
}



// WEBPACK FOOTER //
// ./src/app/models/student-class-dto.ts